export const setupNewWorkspace = async ({ firstName, lastName, email, organisationName }) => {
	const superFetchModule = await import('library/helpers/superFetch');
	const SuperFetch = superFetchModule.default;

	try {
		// Step 1: Create new workspace body with multiple people support
		const createOrgBody = {
			name: organisationName,
			people: [
				{
					firstName,
					lastName,
					email
				}
			]
		};

		// Step 2: Setup new organisation
		await SuperFetch.post('/organisations', createOrgBody, {}, 1);

		return true;
	} catch (error) {
		throw new Error(error);
	}
};
